import { render, staticRenderFns } from "./notice-list.vue?vue&type=template&id=cb69e02c&scoped=true"
import script from "./notice-list.vue?vue&type=script&lang=js"
export * from "./notice-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb69e02c",
  null
  
)

export default component.exports